import { useCallback } from "react";
import { ITriggeredHookResponse, TriggeredHook } from "sonobello.utilities.react";
import { useApi } from "sonobello.utilities.react.axios";

import { AspireObxAxiosInstance } from "../../hooks/useObx";
import ApiRequestPaths from "../../constants/ApiRequestPaths";

interface ApiPayload {
  /** The message of the api payload */
  message: string;
  /** The service associated with the api request */
  service: string;
}

const useReportConnectionError: TriggeredHook<unknown, string> = (): ITriggeredHookResponse<unknown, string> => {
  const {
    res: apiResponse,
    err: apiError,
    loading,
    setReq
  } = useApi<unknown, ApiPayload, undefined, unknown>({
    request: {
      method: "post",
      url: `${import.meta.env.VITE_ASPIRE_API_URL}/${ApiRequestPaths.errorReport}`,
      custom: undefined
    },
    config: { axiosInstance: AspireObxAxiosInstance }
  });

  const execute = useCallback(
    (service: string) => {
      const payload: ApiPayload = {
        message: `Connection error with ${service}`,
        service
      };
      setReq(r => {
        return { ...r, payload, custom: undefined };
      });
    },
    [setReq]
  );

  return {
    result: apiResponse || null,
    error: Boolean(apiError),
    isLoading: loading,
    execute
  };
};

export default useReportConnectionError;
